import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";

// CSS
import "./Subscription.scss";

// Helper
import { setCookie, checkCookie } from "../../Helper/Cookies";
import { apiFetch, getCurrentUser } from "../../Helper/Api";

// Components
import Header from "../../components/Header/Header";
import { SelectEmpty } from "../../components/UI/Controls";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";

// Properties
const properties = require("../../properties.json");

class AddSubscriptions extends Component {
  constructor(props) {
    super(props);
    this.toast = createRef(null);
  }

  state = {
    // Submit Button
    buttonText: "إضافة الإشتراك",
    buttonColor: "",

    // Where the save is drawn when this form is mounted inside a panel: the
    // panel's own header row, so it stays in sight however long the form is.
    headerSlot: null,

    // Teacher Identifier
    branchID: getCurrentUser()?.branchId,
    companyID: properties.company_id,

    // Get Data
    getStudentNames: [],
    getPeriodsList: [],
    getMaterialsList: [],
    getSchoolStages: [],
    getLessons: [],
    getPeriods: [],
    // Inputs Data
    selectedStudent: "",
    selectedStage: null,
    selectedPeriod: null,
    selectedMaterial: null,
    selectedPeriodId: null,
    cost: "",
    teacherId: null,

    // Which menus are still waiting on their options, so an open one says
    // "جارٍ التحميل…" instead of "مفيش عناصر هنا".
    loadingStages: true,
    loadingMaterials: false,
    loadingPeriods: false,
    loadingStudents: false,
  };

  getLessonsByStage = (schoolStagesId, materialId, periodId) => {
    apiFetch("/lessons", { query: { materialId, schoolStageId: schoolStagesId, id: periodId } })
      .then((fetchLessons) => {
        this.setState({ getLessons: fetchLessons });
      })
      .catch((error) => console.error("Error:", error));
  };
  getPeriod(materialId) {
    this.setState({ loadingPeriods: true });
    apiFetch("/periods/by-material", { query: { materialId } })
      .then((grades) => {
        this.setState({ getPeriods: grades, loadingPeriods: false });
      })
      .catch((error) => {
        this.setState({ loadingPeriods: false });
        console.error("Error:", error);
      });
  }

  getMaterialByStage(stageId) {
    this.setState({ loadingMaterials: true });
    apiFetch("/lookup/materials/by-stage", { query: { stageId } })
      .then((grades) => {
        this.setState({ getMaterialsList: grades, loadingMaterials: false });
      })
      .catch((error) => {
        this.setState({ loadingMaterials: false });
        console.error("Error:", error);
      });
  }

  componentDidMount() {
    document.title = properties.site_name + " | دفع شهر جديد";

    // In a panel the save belongs on the header row, where it stays in sight
    // however long the form gets. It is moved there with a portal, so it
    // never leaves this component's tree -- its label and its colour are
    // still driven from this state -- and the `form` attribute on it is what
    // keeps a native submit, and the browser's own required checks, working
    // from outside the <form>. The tree is mounted before this runs, so the
    // slot is already in the DOM if there is one.
    if (this.props.inPanel) {
      const slot = document.querySelector(".ui-panel-slot");
      if (slot) this.setState({ headerSlot: slot });
    }

    // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
    if (!checkCookie("name")) {
      window.localStorage.removeItem("currentTeacher");
      window.location.href = `/`;
    }

    // Get Grades From API
    apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
      .then((grades) => {
        this.setState({ getSchoolStages: grades, loadingStages: false });
      })
      .catch((error) => {
        this.setState({ loadingStages: false });
        console.error("Error:", error);
      });
  }

  getStudentsByStageID = (e) => {
    this.setState({ selectedStage: e.value, loadingStudents: true }, () => {
      // Get Students From API
      apiFetch("/students", {
        query: { branchId: this.state.branchID, schoolStagesId: this.state.selectedStage },
      })
        .then((fetchStudents) => {
          this.setState({ getStudentNames: fetchStudents, loadingStudents: false });
        })
        .catch((error) => {
          this.setState({ loadingStudents: false });
          console.error("Error:", error);
        });
    });
  };

  render() {
    let schoolStages = this.state.getSchoolStages.map((stage) => {
      return { label: stage.name, value: stage.id };
    });

    let studentNames = this.state.getStudentNames.map((student) => {
      return {
        label: `${student.firstName} ${student.fatherName} (${student.mobile})`,
        value: student.id,
      };
    });

    let periodList = this.state.getPeriodsList.map((period) => {
      return { label: period.name, value: period.id };
    });

    let materialList = this.state.getMaterialsList.map((period) => {
      return { label: period.name, value: period.id };
    });

    // The save stays out of reach until the form can actually be saved --
    // the same four values the submit sends, read here so the button can say
    // so before it is pressed rather than after.
    const filled = (v) => v !== null && v !== undefined && String(v).trim() !== "";
    const canSave =
      filled(this.state.selectedStage) &&
      filled(this.state.selectedMaterial) &&
      filled(this.state.selectedPeriod) &&
      filled(this.state.selectedStudent) &&
      filled(this.state.cost);

    var addSubscription = (e) => {
      var _this = this;
      e.preventDefault();

      this.setState({
        buttonText: "جاري الإضافة ...",
        buttonColor: "loading",
      });

      // Send the data to the server
      apiFetch("/students/enrollments", {
        method: "POST",
        body: {
          studentProfileId: this.state.selectedStudent,
          periodId: this.state.selectedPeriod,
          materialId: this.state.selectedMaterial,
          value: this.state.cost,
        },
      })
        .then((created) => {
          _this.setState({
            buttonText: "إضافة الإشتراك",
            buttonColor: "",
          });

          _this.toast.current.show({
            severity: "success",
            summary: "تم بنجاح",
            detail: "تم إضافة الإشتراك بنجاح",
          });

          // Mounted in a panel, a save that finished the job closes it and
          // lets the table behind it refetch. On /subscriptions/add there is
          // no onSaved, so the page behaves exactly as it always did.
          if (_this.props.onSaved) _this.props.onSaved(created);
        })
        .catch((error) => {
          console.error("Error:", error);

          _this.setState({
            buttonText: "إضافة الإشتراك",
            buttonColor: "",
          });

          _this.toast.current.show({
            severity: "error",
            summary: "لم تتم العملية",
            detail: error.message || "خطأ في الإتصال",
          });
        });
    };
    let periods = this.state.getPeriods.map((period) => {
      return { label: period.name, value: period.id };
    });
    let gradesList = this.state.getSchoolStages.map((grade) => {
      return {
        label: grade.name,
        value: grade.id,
      };
    });
    return (
      // `inPanel` is presentation only: the panel already says what this form
      // is, so the page's own title strip and the card's title step aside.
      // Everything else -- fields, submit -- is untouched, and
      // /subscriptions/add still mounts this same component as a page.
      <div className={this.props.inPanel ? "add-lesson-page in-panel" : "add-lesson-page"}>
        {this.props.inPanel ? null : <Header pageName="دفع فتره جديده" />}

        <div className="content">
          <Toast ref={this.toast}></Toast>

          <div className="container">
            <Card title={this.props.inPanel ? null : "دفع فتره جديده"}>
              <form id="add-subscription-form" onSubmit={addSubscription} action="#" method="POST">
                {/* The form is read in two passes, so it is written in two:
                    where the subscription sits, then who it is for and what
                    it costs. Nothing inside a section changed -- same fields,
                    same props, same order, same handlers. */}
                <section className="ui-sec" style={{ "--d": "0ms" }}>
                  <h3>
                    <span className="n">١</span>
                    <span className="t">
                      الفترة
                      <small>حدد مكان الإشتراك: المرحلة، المادة، ثم الفترة نفسها</small>
                    </span>
                  </h3>
                  <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.selectedStage}
                            options={gradesList}
                            required
                            placeholder="اختر"
                            onChange={(e) => {
                              this.setState(
                                { selectedStage: e.value },
                                this.getLessonsByStage(
                                  e.value,
                                  this.state.selectedMaterial,
                                  this.state.selectedPeriod
                                ),
                                this.getMaterialByStage(e.value)

                              );
                              this.getStudentsByStageID(e)
                            }}
                            optionLabel="label"
                            showClear
                            emptyMessage={<SelectEmpty loading={this.state.loadingStages} />}
                          />
                          <label>المرحلة الدراسية</label>
                        </span>
                      </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.selectedMaterial}
                            options={materialList}
                            required
                            placeholder="اختر"
                            onChange={(e) =>
                              this.setState({ selectedMaterial: e.value }
                                ,this.getPeriod(e.value), this.getLessonsByStage(
                                  this.state.selectedStage,
                                  e.value,
                                  this.state.selectedPeriod
                                ),
                                )



                            }
                            optionLabel="label"
                            showClear
                            emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                            // the materials belong to a stage, so there is
                            // nothing to choose from until one is picked
                            disabled={!this.state.selectedStage}
                          />
                          <label>
                            المادة
                            {!this.state.selectedStage ? (
                              <small className="ui-fieldhint">اختر المرحلة الدراسية الأول</small>
                            ) : null}
                          </label>
                        </span>
                      </div>
                    </div>

                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.selectedPeriod}
                            options={periods}
                            required
                            placeholder="اختر"
                            onChange={(e) =>
                              this.setState({ selectedPeriod: e.value },
                                this.getLessonsByStage(
                                  this.state.selectedStage,
                                  this.state.selectedMaterial,
                                  e.value
                                ),
                              //  this.state.selectedType==1?

                              //  :null
                                )




                            }
                            optionLabel="label"
                            showClear
                            emptyMessage={<SelectEmpty loading={this.state.loadingPeriods} />}
                            // periods hang off a material, same story
                            disabled={!this.state.selectedMaterial}
                          />
                          <label>
                            الفترة
                            {!this.state.selectedMaterial ? (
                              <small className="ui-fieldhint">اختر المادة الأول</small>
                            ) : null}
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="ui-sec" style={{ "--d": "70ms" }}>
                  <h3>
                    <span className="n">٢</span>
                    <span className="t">
                      الطالب والمبلغ
                      <small>مين اللي بيشترك في الفترة دي، وبكام</small>
                    </span>
                  </h3>
                  <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <Dropdown
                            value={this.state.selectedStudent}
                            options={studentNames}
                            required
                            placeholder="اختر"
                            onChange={(e) =>
                              this.setState({ selectedStudent: e.value })
                            }
                            optionLabel="label"
                            showClear
                            emptyMessage={<SelectEmpty loading={this.state.loadingStudents} />}
                            // the students are the ones in the chosen stage,
                            // so there is nobody to pick before that
                            disabled={!this.state.selectedStage}
                          />
                          <label>
                            الطالب
                            {!this.state.selectedStage ? (
                              <small className="ui-fieldhint">اختر المرحلة الدراسية الأول</small>
                            ) : null}
                          </label>
                        </span>
                      </div>
                    </div>
                    <div className="p-col-12 p-md-4">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <InputText
                            id="cost"
                            required
                            value={this.state.cost}
                            name="cost"
                            type="text"
                            placeholder="مثال: 150"
                            onChange={(e) => {
                              this.setState({ cost: e.target.value });
                            }}
                          />
                          <label htmlFor="cost">السعر</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </section>

                {/* In a panel the save rides the header row; on the page it
                    keeps its own bar at the end of the form. Same element
                    either way, same state behind it. */}
                {this.state.headerSlot ? (
                  ReactDOM.createPortal(
                    // no cancel beside it: the panel's × already closes
                    <Button
                      form="add-subscription-form"
                      className={`add-button ${this.state.buttonColor}`}
                      label={this.state.buttonText}
                      disabled={!canSave}
                    />,
                    this.state.headerSlot
                  )
                ) : (
                  <div className="p-col-12 p-md-12">
                    <div className="p-inputgroup ui-form-actions">
                      <span className="p-float-label">
                        <Button
                          className={`add-button ${this.state.buttonColor}`}
                          label={this.state.buttonText}
                          disabled={!canSave}
                        />
                      </span>
                    </div>
                  </div>
                )}
              </form>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

export default AddSubscriptions;
